import API from '@utilities/api'
import { body } from '@utilities/dom-elements'
import errorHandler from '@utilities/errors/error-handler'
import Events from '@utilities/events'
import moduleInit from '@utilities/module-init'
import replace from '@utilities/replace'
import ScreenDimensions from '@utilities/screen-dimensions'

const JS_HOOK_PRODUCT_DETAIL_WRAPPER = '[js-hook-product-detail]'
const JS_HOOK_PRODUCT_IMAGE_GALLERY_WRAPPER = '[js-hook-image-gallery-wrapper]'
const JS_HOOK_PRODUCT_PRICE_WRAPPER = '[js-hook-price]'
const JS_HOOK_PRODUCT_BADGES_WRAPPER = '[js-product-badges-wrapper]'
const JS_HOOK_PRODUCT_DELIVERY_WRAPPER = '[js-hook-product-delivery-wrapper]'
const JS_HOOK_PRODUCT_SPARE_PARTS_ANCHOR_WRAPPER = '[js-hook-spare-parts-anchor-link-wrapper]'
const JS_HOOK_PRODUCT_SPARE_PARTS_WRAPPER = '[js-hook-spare-parts-wrapper]'
const JS_HOOK_PRODUCT_SPARE_PARTS_SLIDER_WRAPPER = '[js-hook-spare-parts-slider-wrapper]'
const JS_HOOK_PRODUCT_SPARE_PARTS_VIEWPRODUCT_WRAPPER = '[js-hook-spare-parts-viewproduct-wrapper]'
const JS_HOOK_PRODUCT_SIDEBAR_BLOCK_WRAPPER = '[js-hook-sidebar-block-wrapper]'
const JS_HOOK_PRODUCT_ID = '[js-hook-product-id]'
const JS_HOOK_PRODUCT_TITLE = '[js-hook-product-attribute-title]'
const JS_HOOK_PRODUCT_SUBTITLE = '[js-hook-product-attribute-subtitle]'
const JS_HOOK_PRODUCT_DESIGNERS = '[js-hook-product-designers]'
const JS_HOOK_PRODUCT_ACCORDIONS = '[js-hook-product-accordions]'
const JS_HOOK_PRODUCT_ATTRIBUTE_DESKTOP = '[js-hook-product-attribute-desktop]'
const JS_HOOK_PRODUCT_ATTRIBUTE_MOBILE = '[js-hook-product-attribute-mobile]'
const JS_HOOK_ADD_TO_CART_BUTTON = '[js-hook-add-to-cart]'
const JS_HOOK_ADD_TO_CART_BUTTON_LABEL = '[js-hook-button-label]'
const JS_HOOK_OUT_OF_STOCK_BUTTON = '[js-hook-out-of-stock-button]'
const JS_HOOK_HELP_ME_CHOOSE_BUTTON = '[js-hook-help-me-choose-button]'
const JS_HOOK_SEO_TEXT = '[js-hook-seo-text]'
const JS_HOOK_DESCRIPTION_TEXT = '[js-hook-description-text]'
const JS_HOOK_PRODUCT_BREADCRUMB = '[js-hook-product-breadcrumb]'
const JS_HOOK_PRODUCT_INCLUDED_BULB = '[js-hook-product-included-bulb]'
const JS_HOOK_PRODUCT_SAMPLES = '[js-hook-product-samples-wrapper]'
const JS_HOOK_PRODUCT_ADDED_TO_CART_MODAL = '[js-hook-added-to-cart-modal]'
const JS_HOOK_PRODUCT_STOCK = '[js-hook-product-stock-wrapper]'
const JS_HOOK_MODAL = '[js-hook-modal]'
const JS_HOOK_SWATCH_RADIO = '[js-hook-swatch-radio]'
const JS_HOOK_COLOR_SWATCH = '[js-hook-color-swatch]'
const JS_HOOK_LINKED_PRODUCTS_SLIDER = '[js-hook-linked-products-slider]'
const JS_HOOK_RELATED_SLIDER = '[js-hook-related-slider]'
const JS_HOOK_PRODUCT_DETAIL_BLOCK = '[js-hook-product-detail-block]'
const JS_HOOK_PRODUCT_LIGHTBULBS = '[js-hook-product-lightbulbs]'
const PRODUCT_DETAIL_CLASS = '.c-product-detail'
const JS_HOOK_PRODUCT_DESIGNERS_CONTENT_AREA = '[js-hook-product-designers-content-area]'
const JS_HOOK_PRODUCT_ADD_TO_CART_DATA = '[js-hook-product-add-to-cart-data]'
const JS_HOOK_PRODUCT_ADD_TO_CART_MODAL_DATA = '[add-to-cart-modal-data]'
const JS_HOOK_SEO_DESCRIPTION = '[js-hook-seo-description]';
const JS_HOOK_TOGGLE = '[js-hook-toggle]';
const JS_HOOK_DESIGN_AWARDS = '[js-hook-design-awards]';
// const JS_HOOK_STICKY_BUTTON = '[js-hook-product-detail-sticky-button]';

const SLIDER_HIDDEN = 'slider--hidden'
const ON_ORDER_SECTION = '.fl-onorder-section';
const ADD_TO_CART_SECTION = '.fl-addtocart-section';

class ProductAttribute {
  constructor(element) {
    this.element = element

    this.setUI()
    this.bindEvents()
  }

  static updateHistory(url) {
    Events.$trigger('history::push', {
      data: {
        url,
        state: {
          productChange: true,
        },
      },
    })
  }

  /**
   * @param available is map from product object. False or true
   * @param readyToOrder is map from product object. Default value false
   */
  static shouldShowAddToCart(available, readyToOrder = false) {
    return available && readyToOrder
  }

  static updatePrices({ priceHtml: price }) {
    replace(price, JS_HOOK_PRODUCT_PRICE_WRAPPER)
  }

  static updateBadges({ badgesHtml: badges }) {
    replace(badges, JS_HOOK_PRODUCT_BADGES_WRAPPER)
  }

  static updateDelivery({ deliveryHtml: delivery }) {
    replace(delivery, JS_HOOK_PRODUCT_DELIVERY_WRAPPER)
  }

  static updateImageGallery({ imageGridHtml: imageGallery }) {
    replace(imageGallery, JS_HOOK_PRODUCT_IMAGE_GALLERY_WRAPPER, true)
  }

  static updateProductID({ id: pid }) {
    replace(pid, `${JS_HOOK_PRODUCT_ID}`)
  }

  static updateProductTitle(productName) {
    replace(productName, `${JS_HOOK_PRODUCT_TITLE}`)
    document.title = productName
  }

  static updateProductSubTitle(productSubTitle) {
    replace(productSubTitle, `${JS_HOOK_PRODUCT_SUBTITLE}`)
  }

  static updateProductDesigners({ designersHtml }) {
    replace(designersHtml, `${JS_HOOK_PRODUCT_DESIGNERS}`)
  }

  static updateProductAccordions({ accordionsHtml }) {
    replace(accordionsHtml, `${JS_HOOK_PRODUCT_ACCORDIONS}`)
  }

  static updateSeoText({ longDescription }) {
    replace(longDescription, `${JS_HOOK_SEO_TEXT}`)
  }

  static updateDescriptionText({ shortDescription }) {
    replace(shortDescription, `${JS_HOOK_DESCRIPTION_TEXT}`)
  }

  static updateDesignAwards({ designAwardsHtml }) {
    replace(designAwardsHtml, `${JS_HOOK_DESIGN_AWARDS}`)
  }

  static updateAttributesDesktop({ variationAttributesDesktopHtml: attributes }) {
    replace(attributes, `${JS_HOOK_PRODUCT_ATTRIBUTE_DESKTOP}`)
  }

  static updateAttributesMobile({ variationAttributesMobileHtml: attributes }) {
    replace(attributes, `${JS_HOOK_PRODUCT_ATTRIBUTE_MOBILE}`)
  }

  static updateProductBreadcrumb({ breadcrumbHtml }) {
    replace(breadcrumbHtml, `${JS_HOOK_PRODUCT_BREADCRUMB}`)
  }

  static updateIncludedBulb({ includedBulbHtml }) {
    replace(includedBulbHtml, `${JS_HOOK_PRODUCT_INCLUDED_BULB}`)
  }

  static updateProductSamples({ productSamplesHtml }) {
    replace(productSamplesHtml, `${JS_HOOK_PRODUCT_SAMPLES}`)
  }

  static updateProductAddedToCartModal({ addedToCartModalHtml }) {
    replace(addedToCartModalHtml, `${JS_HOOK_PRODUCT_ADDED_TO_CART_MODAL}`)
  }

  static updateProductStock({ productStockHtml }) {
    replace(productStockHtml, `${JS_HOOK_PRODUCT_STOCK}`)
  }

  static updateSparePartsAnchor({ sparePartsAnchorHtml }) {
    replace(sparePartsAnchorHtml, JS_HOOK_PRODUCT_SPARE_PARTS_ANCHOR_WRAPPER)
  }

  static updateSparePartsList({ sparePartsListHtml }) {
    replace(sparePartsListHtml, `${JS_HOOK_PRODUCT_SPARE_PARTS_WRAPPER}`)
  }

  static updateSparePartsSlider({ sparePartsSliderHtml }) {
    replace(sparePartsSliderHtml, `${JS_HOOK_PRODUCT_SPARE_PARTS_SLIDER_WRAPPER}`)
  }

  static updateSparePartsViewProductButton({ sparePartsViewProductHtml }) {
    replace(sparePartsViewProductHtml, `${JS_HOOK_PRODUCT_SPARE_PARTS_VIEWPRODUCT_WRAPPER}`)
  }

  static updateDesignersContentArea({ designersContentArea }) {
    const designersContentAreaHook = document.querySelector(JS_HOOK_PRODUCT_DESIGNERS_CONTENT_AREA)
    if (designersContentAreaHook) {
      replace(designersContentArea, `${JS_HOOK_PRODUCT_DESIGNERS_CONTENT_AREA}`)
    }
  }

  static updateProductDetailBlock({ productDetailBlock }) {
    replace(productDetailBlock, `${JS_HOOK_PRODUCT_DETAIL_BLOCK}`)
  }

  static updateLightbulbs(lightbulbsHTML) {
    replace(lightbulbsHTML, `${JS_HOOK_PRODUCT_LIGHTBULBS}`)
  }

  static updateLinkedProductsSlider({ linkedProductsSliderHtml }) {
    const linkedProducts = document.querySelector(JS_HOOK_LINKED_PRODUCTS_SLIDER)

    if (linkedProducts) {
      replace(linkedProductsSliderHtml, `${JS_HOOK_LINKED_PRODUCTS_SLIDER}`)

      const ajaxProductTiles = [...linkedProducts.querySelectorAll('.ajax-product-tile')]

      if (ajaxProductTiles) {
        const promises = []

        ajaxProductTiles.forEach((ajaxProductTile) => {
          const { productTileUrl } = ajaxProductTile.dataset

          if (productTileUrl) {
            const promise = API.get(productTileUrl)
              .then((response) => {
                if (response.data) ajaxProductTile.innerHTML = response.data
              })
              .catch((error) => {
                console.info(error)
              })

            promises.push(promise)
          }
        })

        Promise.all(promises)
          .then(() => {
            moduleInit.async('[js-hook-basic-slider]', () =>
              import(/* webpackChunkName: "js/BasicSlider" */ '@components/basic-slider'),
            )
          })
          .catch((error) => {
            console.info(error)
          })
      } else {
        moduleInit.async('[js-hook-basic-slider]', () =>
          import(/* webpackChunkName: "js/BasicSlider" */ '@components/basic-slider'),
        )
      }
    }
  }

  static updateSidebarBlock(data) {
    replace(data, `${JS_HOOK_PRODUCT_SIDEBAR_BLOCK_WRAPPER}`)
  }

  static getPromoPage({ pdpSidebarBlockId }) {
    const sidebarBlockWrapperDataset = document.querySelector(JS_HOOK_PRODUCT_SIDEBAR_BLOCK_WRAPPER)
    if (sidebarBlockWrapperDataset) {
      const { sidebarUrl } = sidebarBlockWrapperDataset.dataset

      if (pdpSidebarBlockId) {
        API.get(sidebarUrl + pdpSidebarBlockId)
          .then((response) => {
            ProductAttribute.updateSidebarBlock(response.data)
          })
          .catch((error) => {
            console.info(error)
            ProductAttribute.updateSidebarBlock('')
          })
      } else {
        ProductAttribute.updateSidebarBlock('')
      }
    }
  }

  static updatePdpSlider(product) {
    const relatedSlider = document.querySelector(JS_HOOK_RELATED_SLIDER)
    const recommendedSlider = document.querySelector(JS_HOOK_LINKED_PRODUCTS_SLIDER)
    const crossSelling = product.crossSellingProductRecommendations

    if (recommendedSlider && relatedSlider) {
      recommendedSlider.classList[crossSelling.show ? 'remove' : 'add'](SLIDER_HIDDEN)
      relatedSlider.classList[crossSelling.show ? 'add' : 'remove'](SLIDER_HIDDEN)
    }
  }

  setAddToCartButton(id) {
    this.ui.onOrderSections.forEach((section) => {
      section.classList.add('d-none');
    });
    this.ui.addToCartSections.forEach((section) => {
      section.classList.remove('d-none');
    });
    this.ui.helpMeChooseButtons.forEach((section) => {
      section.classList.remove('d-none');
    });
    this.ui.addToCartButtons.forEach((button) => {
      button.setAttribute('data-pid', id)
    });
  }

  setGoToStoreButton() {
    this.ui.onOrderSections.forEach((section) => {
      section.classList.remove('d-none');
    });
    this.ui.helpMeChooseButtons.forEach((section) => {
      section.classList.add('d-none');
    });
    this.ui.addToCartSections.forEach((section) => {
      section.classList.add('d-none');
    });
  }

  setDiscontinuedButton() {
    this.ui.onOrderSections.forEach((section) => {
      section.classList.add('d-none');
    });
    this.ui.helpMeChooseButtons.forEach((section) => {
      section.classList.add('d-none');
    });
    this.ui.addToCartSections.forEach((section) => {
      section.classList.add('d-none');
    });
  }

  rebindEvents() {
    // Fire Event to Update Images
    Events.$trigger('lazyimage::update')

    Events.$trigger('in-view::update')
    Events.$trigger('events::dom-reinit')
    Events.$trigger('scroll-to::reinit-elements')

    this.bindModals()

    this.bindSelectEvents()
    this.bindSwatchEvents()
    this.bindRadioEvents()
  }

  static initModules() {
    moduleInit.async('[js-hook-product-attribute]', () =>
      import(/* webpackChunkName: "js/ProductAttribute" */ '@components/product-attribute'),
    )

    moduleInit.async('[js-hook-custom-select-box]', () =>
      import(/* webpackChunkName: "js/CustomSelectBox" */ '@components/custom-select-box'),
    )

    moduleInit.async('[js-hook-accordion]', () =>
      import(/* webpackChunkName: "js/Accordion" */ '@components/accordion'),
    )

    moduleInit.async('[js-hook-high-res-image-gallery]', () =>
      import(/* webpackChunkName: "js/HighResImageGallery" */ '@components/high-res-image-gallery'),
    )

    moduleInit.async('[js-hook-image-zoom]', () =>
      import(/* webpackChunkName: "js/ImageZoom" */ '@components/image-zoom'),
    )

    moduleInit.async('[js-hook-image-modal]', () =>
      import(/* webpackChunkName: "js/ImageModal" */ '@components/image-modal'),
    )

    moduleInit.async('[js-hook-product-sample-modal-toggle]', () =>
      import(
        /* webpackChunkName: "js/ProductSampleModalToggle" */ '@components/product-sample-modal-toggle'
      ),
    )

    moduleInit.async('[js-hook-product-sample-form]', () =>
      import(/* webpackChunkName: "js/ProductSampleForm" */ '@components/product-sample-form'),
    )

    moduleInit.async('[js-hook-add-to-cart]', () =>
      import(/* webpackChunkName: "js/AddToCart" */ '@components/add-to-cart'),
    )

    moduleInit.async('[js-hook-go-to-stores]', () =>
      import(/* webpackChunkName: "js/GoToStore" */ '@components/go-to-stores'),
    )

    moduleInit.async('[js-hook-toggle]', () =>
      import(/* webpackChunkName: "js/Toggle" */ '@components/toggle'),
    )
  }

  static updateGTMAddToCartGA(productAddToCartGTMDataHTML) {
    if (productAddToCartGTMDataHTML) {
      const addToCartDataElement = document.querySelector(JS_HOOK_PRODUCT_ADD_TO_CART_DATA)

      if (addToCartDataElement) addToCartDataElement.outerHTML = productAddToCartGTMDataHTML
    }
  }

  static updateGTMAddToCartGAModalButtonData(addTocartGAData) {
    if (addTocartGAData) {
      const addToCartModalDataElements = document.querySelectorAll(
        JS_HOOK_PRODUCT_ADD_TO_CART_MODAL_DATA,
      )

      if (addToCartModalDataElements) {
        for (let index = 0; index < addToCartModalDataElements.length; index++) {
          const addToCartModalDataElement = addToCartModalDataElements[index]

          addToCartModalDataElement.dataset.gtmObj = addTocartGAData.gtmAddToCart
          addToCartModalDataElement.dataset.ga4Obj = addTocartGAData.gtmAddToCartGA
        }
      }
    }
  }

  static updateGTMViewItemData(viewItemData) {
    if (viewItemData) {
      window.ga4Data = JSON.parse(viewItemData)

      Events.$trigger('gtm::push', { data: { ecommerce: null } })
      Events.$trigger('gtm::push', { data: window.ga4Data })
    }
  }

  setUI() {
    this.ui = {
      selects: [...this.element.querySelectorAll('select')],
      swatches: [...this.element.querySelectorAll(JS_HOOK_COLOR_SWATCH)],
      radios: [...this.element.querySelectorAll(JS_HOOK_SWATCH_RADIO)],
      productDetail: document.querySelector(PRODUCT_DETAIL_CLASS),
      addToCartSections: [...document.querySelectorAll(ADD_TO_CART_SECTION)],
      onOrderSections: [...document.querySelectorAll(ON_ORDER_SECTION)],
      addToCartButtons: [...document.querySelectorAll(JS_HOOK_ADD_TO_CART_BUTTON)],
      addToCartButtonLabels: [
        ...document.querySelectorAll(
          `${JS_HOOK_ADD_TO_CART_BUTTON} ${JS_HOOK_ADD_TO_CART_BUTTON_LABEL}`,
        ),
      ],
      helpMeChooseButtons: [...document.querySelectorAll(JS_HOOK_HELP_ME_CHOOSE_BUTTON)],
      outOfStockButtons: [...document.querySelectorAll(JS_HOOK_OUT_OF_STOCK_BUTTON)],
    }
  }

  updateButtonLabel({ buttonLabel }) {
    this.ui.addToCartButtonLabels.forEach((label) => {
      label.innerText = buttonLabel
    });
  }

  updateButton({ id, available, availability }) {
    if (available) {
      this.setAddToCartButton(id)
    } else if (availability.onOrder) {
      this.setGoToStoreButton()
    } else if (availability.discontinued) {
      this.setDiscontinuedButton()
    }
  }

  bindSelectEvents() {
    this.ui.selects.forEach((select) => {
      select.addEventListener('change', (e) => this.onChangeHandler(e))
    })
  }

  bindRadioEvents() {
    this.ui.radios.forEach((radio) => {
      radio.addEventListener('change', (e) => this.onChangeHandler(e))
    })
  }

  bindSwatchEvents() {
    this.ui.swatches.forEach((swatch) => {
      swatch.addEventListener('click', (e) => this.onClickHandler(e))
    })
  }

  // eslint-disable-next-line class-methods-use-this
  bindModals() {
    const productDetailWrapper = document.querySelector(JS_HOOK_PRODUCT_DETAIL_WRAPPER)

    if (!productDetailWrapper) return

    const modals = [...productDetailWrapper.querySelectorAll(JS_HOOK_MODAL)]

    modals.forEach((modal) => {
      const modalId = modal.id

      Events.$trigger('modal::bind', { data: modalId })
    })
  }

  /**
   * Binds events
   */
  bindEvents() {
    this.bindSelectEvents()
    this.bindSwatchEvents()
    this.bindRadioEvents()

    ProductAttribute.checkDescriptionMoreButton()
    window.addEventListener('resize', () => {
      ProductAttribute.checkDescriptionMoreButton()
    })

    window.addEventListener('popstate', () => {
      // todo: extend updateHTML to variant selects + reinit events
      // instead of reloading page
      // this.getContent(document.location.href);
      window.location.reload()
    })
  }

  static checkDescriptionMoreButton() {
    const seoDescriptions = [...document.querySelectorAll(JS_HOOK_SEO_DESCRIPTION)];

    seoDescriptions.forEach(el => {
      const seoDescriptionBtn = el.querySelector(JS_HOOK_TOGGLE);
      const seoDescriptionText = el.querySelector(JS_HOOK_SEO_TEXT);

      if (seoDescriptionBtn && seoDescriptionText) {
        const style = window.getComputedStyle(seoDescriptionText);
        const lineHeight = parseFloat(style.lineHeight);
        const lines = Math.round(seoDescriptionText.scrollHeight / lineHeight);

        if (lines > 3) {
          seoDescriptionBtn.style.visibility = "visible";
        } else {
          seoDescriptionBtn.style.visibility = "hidden";
        }
      }
    });
  }

  getContent(url) {
    Events.$trigger('loader::show')

    API.get(url)
      .then((response) => this.getContentSuccess(response.data))
      .catch((error) => errorHandler(error))
  }

  updateHtml(product, productAddToCartGTMDataHTML, lightbulbsHTML) {
    if (product.masterName) {
      ProductAttribute.updateProductTitle(product.masterName)
      ProductAttribute.updateProductSubTitle(product.productName)
    } else {
      ProductAttribute.updateProductTitle(product.productName)
    }

    ProductAttribute.updateImageGallery(product)
    ProductAttribute.updatePrices(product)
    ProductAttribute.updateBadges(product)
    ProductAttribute.updateDelivery(product)
    ProductAttribute.updateProductID(product)
    ProductAttribute.updateProductDesigners(product)
    ProductAttribute.updateProductAccordions(product)
    ProductAttribute.updateSeoText(product)
    ProductAttribute.updateDescriptionText(product)
    ProductAttribute.updateDesignAwards(product)
    ProductAttribute.updateAttributesDesktop(product)
    ProductAttribute.updateAttributesMobile(product)
    ProductAttribute.updateProductBreadcrumb(product)
    ProductAttribute.updateIncludedBulb(product)
    ProductAttribute.updateProductSamples(product)
    ProductAttribute.updateProductAddedToCartModal(product)
    ProductAttribute.updateProductStock(product)
    ProductAttribute.updateSparePartsAnchor(product)
    ProductAttribute.updateSparePartsList(product)
    ProductAttribute.updateSparePartsSlider(product)
    ProductAttribute.updateSparePartsViewProductButton(product)
    ProductAttribute.updateLinkedProductsSlider(product)
    ProductAttribute.updateDesignersContentArea(product)
    ProductAttribute.updateProductDetailBlock(product)
    ProductAttribute.updateLightbulbs(lightbulbsHTML)

    ProductAttribute.updatePdpSlider(product)

    ProductAttribute.getPromoPage(product)

    ProductAttribute.updateGTMAddToCartGA(productAddToCartGTMDataHTML)

    this.updateButtonLabel(product)
    this.updateButton(product)

    this.setUI()

    // Bind events again to new DOM elements
    this.rebindEvents()
    ProductAttribute.initModules()

    ProductAttribute.checkDescriptionMoreButton()
    window.addEventListener('resize', () => {
      ProductAttribute.checkDescriptionMoreButton()
    })

    Events.$trigger('loader::hide')
  }

  // eslint-disable-next-line class-methods-use-this
  updateBundleIds(productBundleIds, product) {
    if (productBundleIds) {
      const productDetails = document.querySelector(PRODUCT_DETAIL_CLASS)
      productDetails.dataset.bundledProductIds = productBundleIds
      productDetails.dataset.baseProductId = `${product.id || ''}`
      Events.$trigger('product::specsheet')
    }
  }

  getContentSuccess(data) {
    const { product } = data
    const { productAddToCartGTMDataHTML } = data
    const { lightbulbsHTML } = data
    const { recommendedBulbsObj } = data
    const { gtmViewItem } = data
    const { bundledProductIds } = data

    if (!product) {
      throw new Error('No product data found')
    }

    ProductAttribute.updateHistory(product.selectedProductUrl)
    this.updateHtml(product, productAddToCartGTMDataHTML, lightbulbsHTML)
    this.updateBundleIds(bundledProductIds, product)

    ProductAttribute.updateGTMAddToCartGAModalButtonData(recommendedBulbsObj)
    ProductAttribute.updateGTMViewItemData(gtmViewItem)

    if (!ScreenDimensions.isTabletLandscapeAndBigger) {
      Events.$trigger('scroll-to::scroll', {
        data: {
          target: body,
          offset: 0,
        },
      })
    }
  }

  onChangeHandler(e) {
    let data = e.target.dataset
    if (e.target.nodeName === 'SELECT') {
      data = e.target.options[e.target.selectedIndex].dataset
    }

    if (!data.url) return

    this.getContent(data.url)
  }

  onClickHandler(e) {
    const data = e.target.parentElement.dataset;
    if (!data.url) return

    this.getContent(data.url)
  }
}

export default ProductAttribute
